
/**
 * Booking appointment dialog/form where user does not log in 
 * but instead gives some personal data about him before going further
 * 
 * If patient's data update is successful - call parent's set "onSubmitDone" method
 * with patients data
 */

import React from 'react';
import { Trans } from "react-i18next";
import i18n from  "./../../Documental/Localization/i18n.js";
import HumanName from '../../Documental/Core/HumanName';
import Helper from '../../Documental/AppFeatureFlags/Helper';
import { ContactPoint } from '../../Documental/Core/ContactPoint';
import Button from './../Buttons/Button';
import ErrorBar from "./../ErrorBar/ErrorBar";
import PhoneCountryCode from "./PhoneCountryCode";

import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';

import StateMachine from 'react-simple-state/dist';
const appState = new StateMachine();



class BookingStartForm extends React.Component {

  constructor( props ) {
    super( props );

    let currentAppMode = appState.getState( 'app-main-mode' );

    let formValues = {
      "firstName" : "",
      "surName" : "",
      "birthDate" : "",
      "identifierCode" : "",
      "contactEmail" : "",
      "contactPhone" : ""
    };

    let birthDateParts = {
      "year" : "",
      "month" : "", 
      "day" : ""
    }

    let phoneParts = {
      "country" : "",
      "number" : ""
    }
    
    this.dateFormat = 'yyyy-MM-dd'; 
    this.dateFormatDisplay = 'YYYY-MM-DD'; // for placeholder
    this.dateSelectorType = "selects"; // selects  native

    // prefill patien form if possible
    let patients = window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "Patient"
    });
    
    // thereshould be only 1 patient resource
    for( var ii in patients ){
      // pseudoName = patients[ ii ].getAnonymousName();
      if( patients[ ii ].getBirthDay() !== null ){
        formValues.birthDate = patients[ ii ].getBirthDay();
        birthDateParts = this.dateStringToParts( formValues.birthDate );
      }
      
      let phoneObj = patients[ ii ].getFirstTelecomBySystemCode( "phone" );
      if( phoneObj !== null ){
        formValues.contactPhone = patients[ ii ].getFirstTelecomBySystemCode( "phone" ).getValue();
      }

      let emailObj = patients[ ii ].getFirstTelecomBySystemCode( "email" );
      if( emailObj !== null ){
        formValues.contactEmail = patients[ ii ].getFirstTelecomBySystemCode( "email" ).getValue();
      }
      
      let officialName = patients[ ii ].getOfficialName();
      if( officialName !== null ){
        formValues.firstName = officialName.getFirstName();
        formValues.surName = officialName.getLastName();
      }

    }

    let modeUkrainan = false;
    if( currentAppMode.appMainMode === "app-main-mode-ukrainan" ){
      modeUkrainan = true;
    }
    
    let modeFreeAssessment = false;
    if( currentAppMode.appMainMode === "app-main-mode-free-assessment" ){
      modeFreeAssessment = true;
    }

    this.state = {
      "forceRender" : 1,
      "formSubmitting" : false,
      "formSubmissionError" : "",
      "modeFreeAssessment" : modeFreeAssessment,
      "modeUkrainan" : modeUkrainan,
      "appMainMode" : currentAppMode.appMainMode,
      "birthDateParts" : birthDateParts,
      "phoneParts" : phoneParts,
      "formValues" : formValues,
      "formErrors" : {
        "firstName" : "",
        "surName" : "",
        "identifierCode" : "",
        "birthDate" : "",
        "contactEmail" : "",
        "contactPhone" : ""
      }
    }

    this.timerPatientDataSyncedPoll = null;
    this.timerPollServiceRequestSyncedPoll = null;
    this.patientSynced = false;
    this.patientIdSyncingTimeoutCount = 0;
    this.serviceRequestSyncingTimeoutCount = 0;
    this.patientIdSyncing = null;

    this.phonecountryCode = new PhoneCountryCode();
    
    this.handleSubmitClick = this.handleSubmitClick.bind(this);
  }


  componentWillUnmount() {
    if( this.timerPatientDataSyncedPoll !== null ){
      clearTimeout( this.timerPatientDataSyncedPoll );
      this.timerPatientDataSyncedPoll = null;
    }
    if( this.timerPollServiceRequestSyncedPoll !== null ){
      clearTimeout( this.timerPollServiceRequestSyncedPoll );
      this.timerPollServiceRequestSyncedPoll = null;
    }
    
  }


  handleSubmitClick(event) {
    let formData         = this.state.formValues;
    let validationResult = this.validateForm();

    console.log("validation result");
    console.log(validationResult);

    if( validationResult.hasErrors ){
      this.setState({
        "formErrors" : validationResult.formErrors,
        "formSubmitting" : false,
        "forceRender" : ( this.state.forceRender + 1 )
      });
      return;
    }

    let items = window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "Patient"
    });

    let currentLanguage = i18n.language;
    let currentLanguageDisplay = '';

    if( currentLanguage === 'uk' ){
      currentLanguageDisplay = 'Ukrainian';
    }
    if( currentLanguage === 'et' ){
      currentLanguageDisplay = 'Estonian';
    }
    if( currentLanguage === 'ru' ){
      currentLanguageDisplay = 'Russian';
    }
    if( currentLanguage === 'en' ){
      currentLanguageDisplay = 'English';
    }

    // thereshould be only 1 patient resource, update that with available info
    for( var ii in items ){
      if( this.state.modeFreeAssessment ){
        // update id code  .
        items[ ii ].replaceIdentifierCode( formData.identifierCode );
      } else {
        items[ ii ].setOfficialName( new HumanName( "official", formData.firstName, formData.surName ) );
        items[ ii ].updateTelecomBySystemCode( new ContactPoint( formData.contactEmail, "email", "home" ) );
        items[ ii ].updateTelecomBySystemCode( new ContactPoint( formData.contactPhone, "phone", "home" ) );
        items[ ii ].setBirthDay( formData.birthDate );
        if( formData.identifierCode !== ""){// in modeUkrainan this field is optional. Update only if  given
          items[ ii ].replaceIdentifierCode( formData.identifierCode );
        }
      }

      if( currentLanguage !== "" ){
        items[ ii ].addCommunicationLanguage(
          currentLanguage,
          currentLanguageDisplay,
          true
        );
      }

      this.patientSynced = false;
      this.patientIdSyncingTimeoutCount = 0;
      this.patientIdSyncing = items[ ii ].getId();

      window.appEntityStore.saveResource( items[ ii ] );

      this.pollPatientSyncDone();
    }

    if( items.length < 1 ){
      console.log('Not logged in- try again');
      
      this.setState({
        "forceRender" : ( this.state.forceRender + 1 ),
        "formErrors" : validationResult.formErrors,
        "formSubmissionError" : i18n.t("An technical error occurred, please try again.")
      });
      return false;
    }

    this.setState({
      "formSubmitting" : true,
      "formErrors" : validationResult.formErrors,
      "formSubmissionError" : "",
      "forceRender" : ( this.state.forceRender + 1 )
    });

  }


  /**
   * Validate form 
   * 
   * @return obj
   */
  validateForm() {
    let validationResult = {
      "hasErrors" : false,
      "formErrors" : {
        "firstName" : "",
        "surName" : "",
        "birthDate" : "",
        "contactEmail" : "",
        "identifierCode" : "",
        "contactPhone" : ""
      }
    };

    let formData   = this.state.formValues;

    // if in FreeAssessment mode- validate only isikukood / identifierCode field
    // In ukraine mode - validate only isikukood / identifierCode field if it's filled since it's optional
    if( this.state.modeFreeAssessment ){
      if( formData.identifierCode.trim().length < 1 ){
        validationResult.formErrors.identifierCode = i18n.t( "Please fill in the required field" );
        validationResult.hasErrors = true;
        return validationResult;
      }
      if( formData.identifierCode.trim().length !== 11 ){
        validationResult.formErrors.identifierCode = i18n.t( "Please fill in the field correctly" );
        validationResult.hasErrors = true;
      }
      return validationResult;
    }

    if( this.state.modeUkrainan && formData.identifierCode.trim().length > 0 ){
      if( formData.identifierCode.trim().length !== 11 ){
        validationResult.formErrors.identifierCode = i18n.t( "Please fill in the field correctly" );
        validationResult.hasErrors = true;
      }
    }

    
    //basic validation
    if( formData.firstName.trim().length < 2 ){
      validationResult.formErrors.firstName = i18n.t( "Please fill in the required field" );
      validationResult.hasErrors = true;
    }
    if( formData.surName.trim().length < 2 ){
      validationResult.formErrors.surName = i18n.t( "Please fill in the required field" );
      validationResult.hasErrors = true;
    }
    if( formData.contactEmail.trim().length < 2 || !this.validateEmail( formData.contactEmail ) ){
      validationResult.formErrors.contactEmail = i18n.t( "Please fill in the required field" );
      validationResult.hasErrors = true;
    }
    if( formData.birthDate.trim().length < 2 ){
      validationResult.formErrors.birthDate = i18n.t( "Please fill in the required field" );
      validationResult.hasErrors = true;
    }
    if( formData.contactPhone.trim().length < 2 ){
      validationResult.formErrors.contactPhone = i18n.t( "Please fill in the required field" );
      validationResult.hasErrors = true;
    }
    
    // check is date valid?
    if( validationResult.formErrors.birthDate === "" ){
      let dateResult = this.checkDateValid( formData.birthDate );
      if( !dateResult.valid ){
        validationResult.formErrors.birthDate = dateResult.message;
        validationResult.hasErrors = true;
      }
    }

    return validationResult;
  }


  checkDateValid( dateString ){
    let result = {
      "valid" : true,
      "message" : ""
    };
    
    return result;
  }

  pollPatientSyncDone = () => {
    var that = this;

    if ( this.timerPatientDataSyncedPoll != null) {
      clearTimeout( this.timerPatientDataSyncedPoll );
    }
    
    if( this.patientIdSyncingTimeoutCount > 25 ){
      //this.props.onSubmitDone( this.patientIdSyncing, this.state.formValues );
      //return;

      that.setState({
        "formSubmitting" : false,
        "formSubmissionError" : i18n.t("An technical error occurred, please try again."),
        "forceRender" : ( this.state.forceRender + 1 )
      });
      return;
    }
    
    let testPatientResource = window.appEntityStore.getEntityByEntityId( this.patientIdSyncing );
    let syncing = window.appEntityStore.isRecourceSyncing( testPatientResource );

    if( syncing ){
      this.patientIdSyncingTimeoutCount++;
      this.timerPatientDataSyncedPoll = setTimeout(function () {
        that.pollPatientSyncDone();
      }, 250 );
      return;
    }

    this.patientSynced = true;
    console.log( 'PATIENT SYNC DONE' );

    // if patient sync is done - do a update on window.mainResult.serviceRequestId 
    // to get HealthCare services list for next step
    let serviceRequest = window.appEntityStore.getResourceById( window.mainResult.serviceRequestId );
    serviceRequest.setStatus( "draft" );
    serviceRequest._resourceLiteral.intent = "plan";
    //let serviceRequestJson = serviceRequest.toObject();
    window.appEntityStore.saveResource( serviceRequest );
    
    this.pollServiceRequestSyncDone();
    
    //if( typeof this.props.onSubmitDone !== "undefined" ){
    //  this.props.onSubmitDone( this.state.formValues );
    //}
  }

  
  pollServiceRequestSyncDone = () => {
    var that = this;
    console.log( "pollServiceRequestSyncDone" );
    
    if ( this.timerPollServiceRequestSyncedPoll != null) {
      clearTimeout( this.timerPollServiceRequestSyncedPoll );
    }
    
    if( this.serviceRequestSyncingTimeoutCount > 50 ){
      that.setState({
        "formSubmitting" : false,
        "formSubmissionError" : i18n.t("An technical error occurred, please try again."),
        "forceRender" : ( this.state.forceRender + 1 )
      });
      return;
    }

    // Used for under-age patients to let htem know that they need to have a  with them
    let acknowledgeExtraInfoStepTextfound = '';
    
    let currentAppMode = appState.getState( 'app-main-mode' );
    let appFeatureFlagsHelper = new Helper();
    let checkOtherHcLoadedCount = appFeatureFlagsHelper.featureIsEnabled('canChoosePractitionerFromAllServiceAtBooking', currentAppMode.featureFlags );

    let serviceRequestTest = window.appEntityStore.getEntityByEntityId( window.mainResult.serviceRequestId );
    let syncing = window.appEntityStore.isRecourceSyncing( serviceRequestTest );
    let proposedHcResourceFound = false;
    let otherHcLoadedCount = 0; // wait for other resources to be loaded as well, in some cases patient can select from multiple services
    let foundServiceId = '-1';// main service id from service request performer
    let foundServiceName = '';// Name of the service ( foundServiceId )
    let foundAllServiceResourceId = null;
    let foundAllServiceId = '';
    let foundAllServiceName = '';
    
    // wait HealthcareService-es to be loaded also
    // let hcsResources = window.appEntityStore.getAllResourcesBySearchParams( { "resourceType" : "HealthcareService" } );
    
    if( !syncing ){
      // ServiceRequest is synced. Now look/wait for HealthcareService that is requested by ServiceRequest.performer(s)
      let serviceRequestTestJson = serviceRequestTest.toObject();
      //let hcsId = serviceRequestTestJson.performer[ 0 ].reference.split("HealthcareService/").join("");

      //Go trough performers and check is there a provider-choice "all" in HealthcareService resources
      //Other one is the main service (probably on first position)
      for( var ii in serviceRequestTestJson.performer ){
        let hcsId2 = serviceRequestTestJson.performer[ ii ].reference.split("HealthcareService/").join("");
        let hcs2 = window.appEntityStore.getResourceById( hcsId2 );
        if( hcs2 !== null ){
          let hcsJson2 = hcs2.toObject();

          if( this.healthcareServiceHasProviderChoiceAll( hcsJson2 ) ){
            foundAllServiceId = this.getHealthcareServiceSimplybookId( hcsJson2 );
            console.log('FOUND ALL SERVICE');
            console.log( foundAllServiceId );
            if( foundAllServiceId !== null ){
              foundAllServiceResourceId = hcs2.getId();
              foundAllServiceName = this.getHealthcareServiceNameTranslated( hcsJson2 );
            }
          } else {
            foundServiceId = this.getHealthcareServiceSimplybookId( hcsJson2 );
            console.log('FOUND Main SERVICE');
            console.log( foundServiceId );
            if( foundServiceId !== null ){
              foundServiceName = this.getHealthcareServiceNameTranslated( hcsJson2 );
              proposedHcResourceFound = true;
            }

            if( typeof hcsJson2.extraDetails !== "undefined" ){
              acknowledgeExtraInfoStepTextfound = hcsJson2.extraDetails;
            }
          }

        }
      }


      if( checkOtherHcLoadedCount ){
        let otherHcs = window.appEntityStore.getAllResourcesBySearchParams( { "resourceType" : "HealthcareService" } );
        otherHcLoadedCount = otherHcs.length;
      }

    }
    
    if( otherHcLoadedCount < 2 && checkOtherHcLoadedCount ){
      console.log( "FF: Waiting healthcare services to be loaded before continuing" );
      console.log( 'foundAllServiceResourceId: '  + foundAllServiceResourceId );
    }

    let othersCountCheckResult = false;
    if( !checkOtherHcLoadedCount ){
      othersCountCheckResult = true;
    } else {
      if( otherHcLoadedCount > 1 ){ // < 2
        othersCountCheckResult = true;
      }

      // keep services array to window.mainResult so vanilla / jQuery can use this in timewpicker component
      // let otherHcs = window.appEntityStore.getAllResourcesBySearchParams( { "resourceType" : "HealthcareService" } );
    }

    if( 
      syncing || 
      !proposedHcResourceFound || 
      !othersCountCheckResult
    ){
      this.serviceRequestSyncingTimeoutCount++;
      this.timerPollServiceRequestSyncedPoll = setTimeout(function () {
        that.pollServiceRequestSyncDone();
      }, 500 );
      return;
    }

    console.log( 'serviceRequest SYNC DONE' );
    
    /**
    let serviceRequest = window.appEntityStore.getResourceById( window.mainResult.serviceRequestId );
    let serviceRequestJson = serviceRequest.toObject();
    console.log( serviceRequestJson );

    // take the first one (there should only be one option in UK app anyway)
    let hcsId = serviceRequestJson.performer[ 0 ].reference.split("HealthcareService/").join("");
    // HealthcareService HealthcareService/hcs1  

    let hcs = window.appEntityStore.getResourceById( hcsId );
 
    if( hcs !== null ){
      let hcsJson = hcs.toObject();
      if( typeof hcsJson.identifier !== "undefined" ){
        for( var ii in hcsJson.identifier ){
          if( hcsJson.identifier[ 0 ].system === "http://documental.ee/fhir/naming/simplybook/service/id" ){
            foundServiceId = hcsJson.identifier[ 0 ].value;
          }
        }
      }
    }
    */

    //
    window.mainResult.repeatVisitActive = false;

    // main service ID and name
    window.mainResult.bookingServiceId   = foundServiceId;
    window.mainResult.bookingServiceName = foundServiceName;

    window.mainResult.activeMode                     = 'default';
    window.mainResult.showModeDefault                = true;
    window.mainResult.showModeAllDoctors             = ( foundAllServiceResourceId !== null && checkOtherHcLoadedCount ) ? true : false; // actually not needed since we wait for it, otherwise error occurs
    window.mainResult.showModeRepeatVisit            = false;
    
    window.mainResult.allDoctorsBookingServiceId     = foundAllServiceId;
    window.mainResult.allDoctorsBookingServiceName   = foundAllServiceName;
    
    window.mainResult.repeatVisitServicesProposed = [];// simplebook.me service ID's to show as option on timepicker in repeat visit mode

    // Show extra info before moving to next step
    // Mainly used for HealthcareService.extraDetails display
    if( acknowledgeExtraInfoStepTextfound !== "" ){
      window.mainResult.acknowledgeExtraInfoStep = {
        show : true,
        text : acknowledgeExtraInfoStepTextfound
      }
    }

    console.log( 'window.mainResult after sync:: ' );
    console.log( window.mainResult );
    
    if( typeof this.props.onSubmitDone !== "undefined" ){
      this.props.onSubmitDone( this.state.formValues );
    }
  }


  /**
   * Look for provider-choice "all" in HealthcareService resource json
   * 
   * "extension": [
   *      {
   *        "url": "http://documental.ee/fhir/extension/healthcareservice/provider-choice",
   *      "valueCode": "all"
   *      }
   *    ],
   *
   * @param object hd 
   * @return booolean
   */

  healthcareServiceHasProviderChoiceAll( hd ){
    if( typeof hd.extension !== "undefined" ){
      for( var ii in hd.extension ){
        if( 
          typeof hd.extension[ ii ].url !== "undefined" && 
          hd.extension[ ii ].url === "http://documental.ee/fhir/extension/healthcareservice/provider-choice"
        ){
          if(
            typeof hd.extension[ ii ].valueCode !== "undefined" && 
            hd.extension[ ii ].valueCode === "all"
          ){
            return true;
          }
        }
      }
    }

    return false;
  }


  /**
   * Find simplybook.me event_id (service) from 
   * HealthcareService resource json
   *
   * @param object hcsJson 
   * @return booolean|null
   */

  getHealthcareServiceSimplybookId( hcsJson ){
    
    if( typeof hcsJson.identifier !== "undefined" ){
      for( var ii in hcsJson.identifier ){
        if( 
          hcsJson.identifier[ ii ].system === "http://documental.ee/fhir/naming/simplybook/service/id" && 
          typeof hcsJson.identifier[ ii ].value !== "undefined"
        ){
          return hcsJson.identifier[ ii ].value;
        }
      }
    }

    return null;
  }


  /**
   * 
        "name": "Repeat visit (en)",
        "communication": [
          {
            "coding": [
              {
                "system": "urn:ietf:bcp:47",
                "code": "en",
                "display": "English"
              }
            ]
          }
        ]
   *
   * @param object hc 
   * @return booolean
   */

  getHealthcareServiceNameTranslated( hd ){
    if( typeof hd.name !== "undefined" ){
      return hd.name;
    }

    return "";
  }

  
  handleFieldChange ( fieldKey, newValue ){
    let currentForm = this.state.formValues;

    if( fieldKey === "firstName" ){
      currentForm.firstName = newValue;
    }
    if( fieldKey === "surName" ){
      currentForm.surName = newValue;
    }
    if( fieldKey === "contactEmail" ){
      currentForm.contactEmail = newValue;
    }
    if( fieldKey === "identifierCode" ){
      currentForm.identifierCode = newValue;
    }
    if( fieldKey === "contactPhone" ){
      currentForm.contactPhone = newValue;
    }
    if( fieldKey === "birthDate" ){
      currentForm.birthDate = newValue;
    }
    
    this.setState({
      "formValues" : currentForm,
      "formSubmissionError" : "",
      "forceRender" : ( this.state.forceRender + 1 )
    });
  }


  handleDateChageFromDateSelector( date, obj, event ){
    let currentForm = this.state.formValues;

    currentForm.birthDate = event.state.value;
    
    this.setState({
      formValues : currentForm,
      "forceRender" : ( this.state.forceRender + 1 )
    });
  }

  handleDatePartChange ( fieldKey, newValue ){
    let partValues = this.state.birthDateParts;
    let currentForm = this.state.formValues;

    if( fieldKey === "day" ){
      partValues.day = newValue;
    }
    if( fieldKey === "month" ){
      partValues.month = newValue;
    }
    if( fieldKey === "year" ){
      partValues.year = newValue;
    }

    if( partValues.year && partValues.month && partValues.day ){
      let formattedMonth = partValues.month < 10 ? '0' + partValues.month : partValues.month;
      let formattedDay = partValues.day < 10 ? '0' + partValues.day : partValues.day;
      currentForm.birthDate = partValues.year + "-" + formattedMonth + "-" + formattedDay;
    } else {
      currentForm.birthDate = "";
    }

    console.log( currentForm );
    console.log( partValues );
    
    this.setState({
      "formValues" : currentForm,
      "birthDateParts" : partValues,
      "formSubmissionError" : "",
      "forceRender" : ( this.state.forceRender + 1 )
    });
  }

  

  handlePhonePartChange ( fieldKey, newValue ){
    let partValues = this.state.phoneParts;
    let currentForm = this.state.formValues;

    if( fieldKey === "country" ){
      partValues.country = newValue;
    }

    if( fieldKey === "number" ){
      partValues.number = newValue;
    }

    if( partValues.country && partValues.number ){
      currentForm.contactPhone = partValues.country + " " + partValues.number;
    } else {
      currentForm.contactPhone = "";
    }

    console.log( currentForm );
    console.log( partValues );
    
    this.setState({
      "formValues" : currentForm,
      "phoneParts" : partValues,
      "formSubmissionError" : "",
      "forceRender" : ( this.state.forceRender + 1 )
    });
  }


  formatDate( date, format, locale ) {
    return dateFnsFormat(date, format, { locale });
  }

  
  parseDate( str, format, locale ) {
    const parsed = dateFnsParse(str, format, new Date(), { locale });
    if (DateUtils.isDate(parsed)) {
      return parsed;
    }
    return undefined;
  }

  
  dateStringToParts( str ) {
    let birthDateParts = {
      "year" : "",
      "month" : "", 
      "day" : ""
    }

    if( str.length < 9 ){
      return birthDateParts;
    }

    // From yyyy-mm-dd 
    let startDateYear =   str.substring( 0, 4 );
    let startDateMonth =  str.substring( 5, 7 );
    let startDateDay =    str.substring( 8, 10 );

    birthDateParts.year  = parseInt( startDateYear, 10 );
    birthDateParts.month = parseInt( startDateMonth, 10 );
    birthDateParts.day   = parseInt( startDateDay, 10 );

    return birthDateParts;
  }
  
  
  createDayOptions( year, month ) {
    let dayOptions = [];
    
    month = parseInt(month, 10) || 0;
    year = parseInt(year, 10) || 0;

    if( month < 1 || year < 1 ){
      return dayOptions;
    }

    // Here January is 1 based
    // Day 0 is the last day in the previous month
    let days = new Date(year, month, 0).getDate();
    // Here January is 0 based
    // return new Date(year, month+1, 0).getDate();
    for (var i = 1; i <= days; i++) {
      dayOptions.push(i);
    }

    return dayOptions;
  }
  
  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  render() {
    var that = this;

    let newErrorKey = "error-" + this.state.forceRender;

    let firstNameClasses = "form-field " + ( this.state.formErrors.firstName !== "" ? "field-error" : "" );
    let surNameClasses   = "form-field " + ( this.state.formErrors.surName !== "" ? "field-error" : "" );
    let contactEmailClasses   = "form-field " + ( this.state.formErrors.contactEmail !== "" ? "field-error" : "" );
    let identifierCodeClasses = "form-field " + ( this.state.formErrors.identifierCode !== "" ? "field-error" : "" );
    let contactPhoneClasses   = "form-field " + ( this.state.formErrors.contactPhone !== "" ? "field-error" : "" );
    let birtDateClasses   = "form-field " + ( this.state.formErrors.birthDate !== "" ? "field-error" : "" );
    
    let optionChooseYear = i18n.t("Year");
    let yearOptions = [];
    for (var i = 2016; i >= 1900; i--) {
      yearOptions.push(i);
    }
    
    let optionChooseMonth = i18n.t("Month");
    let monthOptions = [
      { "value" : 1,  "display" : i18n.t("January") },
      { "value" : 2,  "display" : i18n.t("February") },
      { "value" : 3,  "display" : i18n.t("March") },
      { "value" : 4,  "display" : i18n.t("April") },
      { "value" : 5,  "display" : i18n.t("May") },
      { "value" : 6,  "display" : i18n.t("June") },
      { "value" : 7,  "display" : i18n.t("July") },
      { "value" : 8,  "display" : i18n.t("August") },
      { "value" : 9,  "display" : i18n.t("September") },
      { "value" : 10, "display" : i18n.t("October") },
      { "value" : 11, "display" : i18n.t("November") },
      { "value" : 12, "display" : i18n.t("December") },
    ];

    let optionChooseDay = i18n.t("Day");
    let dayOptions = this.createDayOptions( this.state.birthDateParts.year, this.state.birthDateParts.month );
    
    //
    let submitButtonText = i18n.t("Book an appointment");

    let explainText1 = "";
    if( this.state.modeFreeAssessment ){
      explainText1 = i18n.t("Please enter your personal ID number to start the booking");
      submitButtonText = i18n.t("Confirm");
    }

    // Show and hide fields
    let showFirstName = true;
    let showSurName   = true;
    let showBirthDate = true;
    let showIdentifierCode = true;
    let showIdentifierCodeUkrExplainer = false;
    let showContactPhone   = true;
    let showContactEmail   = true;
    
    if( this.state.modeFreeAssessment ){
      showFirstName = false;
      showSurName   = false;
      showBirthDate = false;
      showIdentifierCode = true;
      showContactPhone   = false;
      showContactEmail   = false;
    }
    
    if( this.state.modeUkrainan ){
      showIdentifierCodeUkrExplainer = true;
    }
    

    return (
      <div className="form">
        
        
        {( this.state.formSubmissionError ) && (
          <ErrorBar key={newErrorKey} message={this.state.formSubmissionError} />
        )}


        {( explainText1 !== "" ) && (
          <h2 className="booking-start-form-explainer">
            {explainText1}
          </h2>
        )}


        {( showFirstName ) && (
          <div className={firstNameClasses}>
            <label><Trans>First name</Trans></label>
            <input 
              name="firstName" 
              value={this.state.formValues.firstName} 
              onChange={(event) => that.handleFieldChange( "firstName", event.target.value ) }
            />
            {( this.state.formErrors.firstName !== "" ) && (
              <div className="field-error-text">
                <span className="icon-warning"></span>
                {this.state.formErrors.firstName}
              </div>
            )}
          </div>
        )}

        {( showSurName ) && (
          <div className={surNameClasses}>
            <label><Trans>Surname</Trans></label>
            <input 
              name="surName" 
              value={this.state.formValues.surName} 
              onChange={(event) => that.handleFieldChange( "surName", event.target.value ) }
            />
            {( this.state.formErrors.surName !== "" ) && (
              <div className="field-error-text">
                <span className="icon-warning"></span>
                {this.state.formErrors.surName}
              </div>
            )}
          </div>
        )}
        
        {/*
          et - (pp.kk.aasta)
          en - (dd.mm.yyyy)
          ru - (день.месяц.год)
          uk - (день.місяць.рік)
        */}
        {( showBirthDate ) && (
          <div className={birtDateClasses}>
            <label><Trans>Date of birth</Trans></label>

            {( this.dateSelectorType === "native" ) && (
              <input name="birthDate" 
                value={this.state.formValues.birthDate} 
                onChange={(event) => that.handleFieldChange( "birthDate", event.target.value ) }
                type="date" placeholder="1999-01-01"
              />
            )}
            

            {( this.dateSelectorType === "selects" ) && (
              <div className="grid grid-flow-col grid-cols-3 gap-x-4" >
                <div>
                  <select name="year" className="input" value={this.state.birthDateParts.year} onChange={(event) => that.handleDatePartChange( "year", event.target.value ) } >
                    <option value="" key="choose1">{optionChooseYear}</option>
                    {yearOptions.map(function( yearNr, index ){
                      return <option value={yearNr} key={yearNr}>{yearNr}</option>
                    })}
                  </select>
                </div>

                <div>
                  <select name="month" className="input" value={this.state.birthDateParts.month} onChange={(event) => that.handleDatePartChange( "month", event.target.value ) } >
                    <option value="" key="choose1">{optionChooseMonth}</option>
                    {monthOptions.map(function( monthObj, index ){
                      return <option value={monthObj.value} key={monthObj.value}>{monthObj.display}</option>
                    })}
                  </select>
                </div>

                <div>
                  <select name="day" className="input" value={this.state.birthDateParts.day} onChange={(event) => that.handleDatePartChange( "day", event.target.value ) } >
                    <option value="" key="choose1">{optionChooseDay}</option>
                    {dayOptions.map(function( dayNr, index ){
                      return <option value={dayNr} key={dayNr}>{dayNr}</option>
                    
                    })}
                  </select>
                </div>
              </div>
            )}

            {/*
            <DayPickerInput
              format={this.dateFormat}
              formatDate={this.formatDate}
              parseDate={this.parseDate}
              type="text" 
              placeholder={this.dateFormatDisplay}
              onDayChange={this.handleDateChageFromDateSelector.bind(this)}
              selectedDays={this.state.formValues.birthDate}
              maxDetail="decade" 
            />
            */}

            {( this.state.formErrors.birthDate !== "" ) && (
              <div className="field-error-text">
                <span className="icon-warning"></span>
                {this.state.formErrors.birthDate}
              </div>
            )}
          </div>
        )}


        {/*
          When ID code is asked from ukraine mode, it's optional field and we change the label too
        */}
        {( showIdentifierCode ) && (
          <div className={identifierCodeClasses}>
            {( !showIdentifierCodeUkrExplainer ) && (
            <label><Trans>National identification number</Trans></label>
            )}
            {( showIdentifierCodeUkrExplainer ) && (
            <label><Trans>Estonian identification number</Trans></label>
            )}

            {( showIdentifierCodeUkrExplainer ) && (
              <div className="text-xs mb-2"><label><Trans>Fill only if you have Estonian national identification number</Trans></label></div>
            )}

            <input 
              name="identifierCode" 
              value={this.state.formValues.identifierCode} 
              onChange={(event) => that.handleFieldChange( "identifierCode", event.target.value ) }
            />
            {( this.state.formErrors.identifierCode !== "" ) && (
              <div className="field-error-text">
                <span className="icon-warning"></span>
                {this.state.formErrors.identifierCode}
              </div>
            )}
          </div>
        )}


            
        {( showContactEmail ) && (
          <div className={contactEmailClasses}>
            <label><Trans>E-mail</Trans></label>
            <input 
              type="email"
              name="email" 
              value={this.state.formValues.contactEmail} 
              onChange={(event) => that.handleFieldChange( "contactEmail", event.target.value ) }
            />
            {( this.state.formErrors.contactEmail !== "" ) && (
              <div className="field-error-text">
                <span className="icon-warning"></span>
                {this.state.formErrors.contactEmail}
              </div>
            )}
          </div>
        )}

         
        {( showContactPhone ) && (
          <div className={contactPhoneClasses}>
            <label><Trans>Phone (country code)</Trans></label>

            <div className="phone-inputs">
              <div>
                <select name="month" className="input" value={this.state.phoneParts.country} onChange={(event) => that.handlePhonePartChange( "country", event.target.value ) } >
                  <option value="" key="choose1">-</option>
                  {this.phonecountryCode.getReviewedOptions().map(function( pcc, index ){
                    return <option key={index} value={pcc.dialCode}>{pcc.optionDisplay}</option>
                  })}
                </select>
              </div>
              <div>
                <input 
                    type="text"
                    name="contactPhone" 
                    value={this.state.phoneParts.number} 
                    onChange={(event) => that.handlePhonePartChange( "number", event.target.value ) }
                  />
              </div>
            </div>
            
            {( this.state.formErrors.contactPhone !== "" ) && (
              <div className="field-error-text">
                <span className="icon-warning"></span>
                {this.state.formErrors.contactPhone}
              </div>
            )}
          </div>
        )}


        <div className="app-fragment pull-bottom-fixed pull-bottom-gradient booking-form-footer">
          
          {( !this.state.formSubmitting ) && (
            <span className="btn dark full-width next mb-6"
              onClick={() => { that.handleSubmitClick(); } }
            >
              {submitButtonText}
            </span>
          )}

          {( this.state.formSubmitting ) && (
            <span className="btn dark full-width loading-full mb-6 disabled"
            >
            </span>
          )}
          
          {/** 
          <div className="text-center full-width text-xs mb-6">
            Aja broneerimine avatakse uues veebilehitseja aknas Calendry lahenduses.
          </div>
          */}
        </div>

        <div className="invisible on-for-taking-up-space-same-amount-as-real-button-above">
          <Button className="dark mb-6">
            {submitButtonText}
          </Button>
          {/** 
          <div className="text-center full-width text-xs mb-6">
            Aja broneerimine avatakse uues veebilehitseja aknas Calendry lahenduses.
          </div>
          */}
        </div>
        
      </div>
    );
  }

}

export default BookingStartForm; 